<div class="container-fluid accordion-container accordion-inner"
  [ngClass]="{'accordion-error': question?.validationError}" id="accordion_question_{{question?.id}}">
  <mat-accordion class="accordion" multi>
    <mat-expansion-panel [expanded]="accordionOpened">
      <mat-expansion-panel-header class="py-2">
        <mat-panel-title>
          <span>
            {{ question.question }}
            @if (question.required) {
              *
            }
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (isResponse && question?.response) {
        @if (isConsensusQuestion) {
          <h4 class="font-weight-bold col-12 w-100 pl-0 mt-3 mb-2 d-flex align-items-center section-title-purple">
            <mat-icon class="section-icon mr-2">handshake</mat-icon>
            {{ "service.survey-service.question-typologies.consensus.title" | translate }}
          </h4>
        }
        @if (hasValidDescription(question?.description)) {
          <!-- <p class="label-box font-weight-bold mb-2">{{ "generic.description" | translate }}</p> -->
          <div class="description-box mb-4">
            <app-formatted-text-preview [content]="question?.description"></app-formatted-text-preview>
          </div>
        }
      @if (isOpenedQuestion) {
        <h4 class="font-weight-bold col-12 w-100 pl-0 mt-3 mb-2 d-flex align-items-center section-title-purple">
          <mat-icon class="section-icon mr-2">chat</mat-icon>
          {{ "service.survey-service.question-typologies.opened.title" | translate }}
        </h4>
        <p class="mb-3 text-muted ml-2">
          {{ "pages.surveys.response.opened.instruction" | translate }}
        </p>
        @if (!isConsensusQuestion) {
          <div class="answer-card">
            <mat-form-field class="w-100 answer-field" appearance="outline">
              <mat-label>
                {{
                "generic.your-answer" | translate
                }}
              </mat-label>
              <ng-container>
                <textarea [required]="question.required" class="description" matInput rows="4"
                  name="criterio_description{{question.id}}_response" [(ngModel)]="question.response.answer" [ngModelOptions]="{standalone: true}"
                  [disabled]="survey.answered || isSpeechToTextBusy">
                </textarea>
              </ng-container>
            </mat-form-field>
            @if (!survey.answered && survey?.customs?.speech_to_text_enabled) {
              <div class="answer-speech-recorder-row">
                <app-speech-to-text-recorder
                  [surveyId]="survey?.id"
                  [questionId]="question?.id"
                  [disabled]="survey.answered || isSpeechToTextBusy"
                  [language]="currentTranscriptionLanguage"
                  targetField="answer"
                  [maxDurationSeconds]="300"
                  [isMedical]="!!survey?.customs?.medical_speech_to_text_enabled"
                  (audioAttachmentCreated)="onSpeechToTextAudioAttachmentCreated($event)"
                  (processingStateChanged)="onSpeechToTextProcessingStateChanged($event)"
                  (transcriptionCompleted)="onSpeechToTextCompleted($event)">
                </app-speech-to-text-recorder>
              </div>
            }
          </div>
        }
      }
      @if (isQuantitativeQuestion) {
        <h4 class="font-weight-bold col-12 w-100 pl-0 mt-3 mb-2 d-flex align-items-center section-title-purple">
          <mat-icon class="section-icon mr-2">calculate</mat-icon>
          {{ "service.survey-service.question-typologies.quantitative.title" | translate }}
        </h4>
        <p class="mb-3 text-muted ml-2">
          {{ "pages.surveys.response.quantitative.instruction" | translate }}
        </p>
        <div class="answer-card">
          <div class="d-flex align-items-center flex-wrap mb-3 text-muted" style="gap: 16px; font-size: 0.9rem;">
            @if (getCustoms.measure_unit) {
              <span class="d-flex align-items-center">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; margin-right: 4px;">straighten</mat-icon>
                <strong>{{ "components.decision-table.new-decision-table.compile-proposal.measure-unit" | translate }}:</strong>&nbsp;{{ getCustoms.measure_unit }}
              </span>
            }
            @if (!getCustoms?.use_slider) {
              <span class="d-flex align-items-center">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; margin-right: 4px;">linear_scale</mat-icon>
                <strong>{{ "generic.range-value" | translate }}:</strong>&nbsp;{{ getCustoms.min }} - {{ getCustoms.max }}
              </span>
            }
          </div>
          @if (getCustoms.use_slider) {
            <div class="container row pt-0 pb-4 m-0">
              <div class="slider-preview-wrapper w-100 mt-4" [class.tricolor]="getCustoms?.tricolor">
                <mat-slider name="criterio_quantitative_{{question.id}}_response_slider"
                  class="w-100 cdk-focused" [discrete]="true" [min]="getCustoms.min" [max]="getCustoms.max" [step]="getCustoms.step"
                  [disabled]="survey.answered" color="primary">
                  <input matSliderThumb name="criterio_quantitative_{{question.id}}_response" [max]="getCustoms.max"
                    [min]="getCustoms.min" [step]="getCustoms.step" [(ngModel)]="question.response.answer" [ngModelOptions]="{standalone: true}">
                </mat-slider>
              </div>
              <div class="d-flex justify-content-between w-100 mb-2 px-2">
                @if (!getCustoms.use_custom_min_max_labels) {
                  <small class="float-left">{{ 'components.responses.absolutely-not-sure' | translate }}</small>
                  <small class="float-right">{{ 'components.responses.absolutely-sure' | translate }}</small>
                } @else {
                  <small class="float-left">{{ getCustoms.min_label }}</small>
                  <small class="float-right">{{ getCustoms.max_label }}</small>
                }
              </div>
            </div>
          }
          @if (!getCustoms.use_slider) {
            <div style="max-width: 250px;" class="answer-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ "generic.your-answer" | translate }}</mat-label>
                <input type="number" matInput name="value" step="1" [max]="getCustoms.max"
                  [min]="getCustoms.min" [disabled]="survey.answered" [(ngModel)]="question.response.answer" [ngModelOptions]="{standalone: true}">
              </mat-form-field>
            </div>
          }
        </div>
      }
        @if (isConsensusQuestion) {
          <p class="mb-3 text-muted ml-2">
            {{ "pages.surveys.response.consensus.instruction" | translate }}
          </p>
          <div class="answer-card">
            <div class="d-flex my-2 toogle-button-container consensus-toggle-container justify-content-center">
              <mat-button-toggle-group [disabled]="survey.answered" name="fontStyle" aria-label="Font Style"
                [(ngModel)]="question.response.answer" [ngModelOptions]="{standalone: true}" [hideMultipleSelectionIndicator]="true"
                [hideSingleSelectionIndicator]="true" class="consensus-toggle-group">
                <mat-button-toggle value="AGREE" class="green">
                  <mat-icon class="consensus-icon">thumb_up</mat-icon>
                  {{ 'components.responses.consensus.agree' | translate }}
                </mat-button-toggle>
                @if (!question.required) {
                  <mat-button-toggle value="ABSTAINED" class="yellow">
                    {{ 'components.responses.consensus.abstained' | translate }}
                  </mat-button-toggle>
                }
                <mat-button-toggle value="DISAGREE" class="red">
                  <mat-icon class="consensus-icon">thumb_down</mat-icon>
                  {{ 'components.responses.consensus.disagree' | translate }}
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            @if (getCustoms.use_slider) {
              <div class="container row pt-0 pb-4 m-0 mt-4">
                <small class="col-12">{{ 'components.responses.ask-confidence' | translate }}</small>
                <div class="slider-preview-wrapper w-100 mt-4" [class.tricolor]="getCustoms?.tricolor">
                  <mat-slider name="criterio_consensus_{{question.id}}_response_slider"
                    class="w-100 cdk-focused" [disabled]="survey.answered"
                    color="primary" [discrete]="true" [min]="getCustoms.min" [max]="getCustoms.max" [step]="getCustoms.step">
                    <input matSliderThumb name="criterio_consensus_{{question.id}}_confidence" [max]="getCustoms.max"
                      [min]="getCustoms.min" [step]="getCustoms.step" [(ngModel)]="question.response.customs.confidence" [ngModelOptions]="{standalone: true}">
                  </mat-slider>
                </div>
                <div class="d-flex justify-content-between w-100 mb-2 px-2">
                  @if (!getCustoms.use_custom_min_max_labels) {
                    <small class="float-left">{{ 'components.responses.absolutely-not-sure' | translate }}</small>
                    <small class="float-right">{{ 'components.responses.absolutely-sure' | translate }}</small>
                  } @else {
                    <small class="float-left">{{ getCustoms.min_label }}</small>
                    <small class="float-right">{{ getCustoms.max_label }}</small>
                  }
                </div>
              </div>
            }
          </div>
          <div class="answer-card answer-card-soft mt-4">
            <h4 class="font-weight-bold col-12 w-100 pl-0 mt-0 mb-2 d-flex align-items-center section-title-purple">
              <mat-icon class="section-icon mr-2">rate_review</mat-icon>
              {{ 'generic.feedback' | translate }}
              @if (getCustoms?.feedback_is_mandatory) {
                <span class="ml-1">({{ 'generic.required' | translate }})</span>
              } @if (!getCustoms?.feedback_is_mandatory) {
                <span class="ml-1">({{ "generic.optional" | translate }})</span>
              }
            </h4>
            <mat-form-field class="w-100 answer-field" appearance="outline">
              <mat-label>{{ "generic.your-answer" | translate }}</mat-label>
              <textarea class="description" matInput [required]="getCustoms?.feedback_is_mandatory" rows="3"
              [(ngModel)]="question.response.feedback" [ngModelOptions]="{standalone: true}"></textarea>
            </mat-form-field>
          </div>
        }
        @if (isGridQuestion) {
          <div class="w-100 mb-4">
            @if (isResponse) {
              <h4 class="font-weight-bold col-12 w-100 pl-0 mt-4 mb-2 d-flex align-items-center section-title-purple">
                <mat-icon class="section-icon mr-2">grid_on</mat-icon>
                {{ "service.survey-service.question-typologies.grid.title" | translate | titlecase }}
              </h4>
              <p class="mb-3 text-muted ml-2">
                {{ "pages.surveys.response.grid.instruction" | translate }}
              </p>
            }
            <div class="answer-card answer-card-table">
              <app-grid-question-table class="w-100" [(rows)]="question.grid_rows" [(columns)]="question.grid_columns"
              [isResponse]="isResponse"></app-grid-question-table>
            </div>
          </div>
        }
        @if (isClassificationQuestion) {
          <div class="w-100 mb-4">
            <h4 class="font-weight-bold col-12 w-100 pl-0 mt-4 mb-2 d-flex align-items-center section-title-purple">
              <mat-icon class="section-icon mr-2">grid_on</mat-icon>
              {{ "service.survey-service.question-typologies.classification.title" | translate | titlecase }}
            </h4>
            <p class="mb-3 text-muted ml-2">
              {{ "pages.surveys.response.classification.instruction" | translate: { sum: (question.customs?.weight_sum || 100) } }}
            </p>
            <div class="answer-card answer-card-table">
              <app-grid-question-table class="w-100" [(rows)]="question.grid_rows" [(columns)]="question.grid_columns"
              [isResponse]="isResponse" [typology]="question.typology" [question]="question" [survey]="survey"></app-grid-question-table>
            </div>
          </div>
        }
        @if (isMultipleChoiceQuestion || isCheckboxQuestion) {
          <div class="mb-4">
            @if (isCheckboxQuestion || (isMultipleChoiceQuestion && !getCustoms.use_cascade_select)) {
              <h4 class="font-weight-bold col-12 w-100 pl-0 mt-4 mb-2 d-flex align-items-center section-title-purple">
                <mat-icon class="section-icon mr-2">format_list_bulleted</mat-icon>
                @if (isCheckboxQuestion) {
                  {{ "service.survey-service.question-typologies.checkbox.title" | translate }}
                } @else {
                  {{ "service.survey-service.question-typologies.multiple-choice.title" | translate }}
                }
              </h4>
              <p class="mb-3 text-muted ml-2">
                @if (isCheckboxQuestion) {
                  {{ "pages.surveys.response.checkbox.instruction" | translate }}
                } @else {
                  {{ "pages.surveys.response.multiple_choice.instruction" | translate }}
                }
              </p>
            }
            <div class="answer-card">
              @if (isMultipleChoiceQuestion) {
                @if (getCustoms?.use_cascade_select) {
                  <h4 class="font-weight-bold col-12 w-100 pl-0 mt-0 mb-2 d-flex align-items-center section-title-purple">
                    <mat-icon class="section-icon mr-2">format_list_bulleted</mat-icon>
                    {{ "service.survey-service.question-typologies.multiple-choice.title" | translate }}
                  </h4>
                  <p class="mb-3 text-muted ml-2">
                    {{ "pages.surveys.response.multiple_choice.instruction" | translate }}
                  </p>
                  <mat-form-field appearance="outline" class="answer-field">
                    <mat-label>Seleziona un'opzione</mat-label>
                    <mat-select name="question_choice_{{question.id}}" [(ngModel)]="question.response.choice" [ngModelOptions]="{standalone: true}"
                      [disabled]="survey.answered">
                      @for (choice of question.choices; track choice) {
                        <mat-option [value]="choice.id">
                          {{ choice.title }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                } @else {
                  <mat-radio-group name="question_choice_radio_{{question.id}}" [disabled]="survey.answered"
                    class="d-block w-100" [(ngModel)]="question.response.choice" [ngModelOptions]="{standalone: true}">
                    @for (choice of question.choices; track choice; let optionIndex = $index) {
                      <div class="choice-option-row">
                        <mat-radio-button [value]="choice.id">{{ choice.title }}</mat-radio-button>
                        @if (question.response.choice === choice.id && choice?.customs?.has_open_response) {
                          <mat-form-field
                            appearance="outline" class="w-100 mt-3 answer-field">
                            <mat-label>{{ "generic.your-answer" | translate }}</mat-label>
                            <input matInput name="question_open_response_{{question.id}}_{{choice?.id}}"
                              [disabled]="survey.answered" [(ngModel)]="question.response.customs.open_response_value" [ngModelOptions]="{standalone: true}">
                          </mat-form-field>
                        }
                      </div>
                    }
                  </mat-radio-group>
                }
              }
              @if (isCheckboxQuestion) {
                <div class="d-block w-100">
                  @for (choice of question.choices; track choice; let optionIndex = $index) {
                    <div class="choice-option-row">
                      <mat-checkbox name="choice_checked_{{question.id}}_{{choice?.id}}" [disabled]="survey.answered"
                        [(ngModel)]="choice.checked" [ngModelOptions]="{standalone: true}">{{ choice.title }}
                      </mat-checkbox>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
        @if (isWeightedQuestion) {
          <div class="mb-4">
            <h4 class="font-weight-bold col-12 w-100 pl-0 mt-4 mb-2 d-flex align-items-center section-title-purple">
              <mat-icon class="section-icon mr-2">format_list_bulleted</mat-icon>
              {{ "generic.options" | translate }}
            </h4>
            <p class="mb-3 text-muted ml-2">
              {{ "pages.surveys.response.weighted.instruction" | translate }}
            </p>
            <div class="answer-card">
              @if (question.customs?.use_exclusivity) {
                <div class="mb-3">
                  <mat-checkbox [checked]="question.response.status === 'ABSTAINED'"
                                (change)="toggleExclusivity($event.checked)"
                                [disabled]="survey.answered"
                                class="font-weight-bold exclusivity-checkbox">
                    {{ question.customs.exclusivity_text || ('components.surveys.exclusivity-text-placeholder' | translate) }}
                  </mat-checkbox>
                </div>
              }
              @for (choice of question.choices; track choice; let optionIndex = $index) {
                <div class="row align-items-center mb-3 m-0">
                  <div class="col-8 pl-0">
                    <span class="option-title-text font-weight-bold">{{ choice.title }}</span>
                  </div>
                  <div class="col-4 pr-0">
                    <mat-form-field appearance="outline" class="w-100 mb-0">
                      <input type="number" matInput
                             [name]="'weighted_choice_' + question.id + '_' + choice.id"
                             [(ngModel)]="question.response.answer[choice.id]"
                             [ngModelOptions]="{standalone: true}"
                             [disabled]="survey.answered || question.response.status === 'ABSTAINED'"
                             (ngModelChange)="onWeightChange()"
                             placeholder="0"
                             min="0">
                    </mat-form-field>
                  </div>
                </div>
              }
              @if (question.response.status !== 'ABSTAINED') {
                <div class="mt-2 p-3 bg-light rounded d-flex justify-content-between align-items-center">
                  <span class="font-weight-bold">{{ 'pages.surveys.response.weighted.total-sum' | translate }}:</span>
                  <span class="badge" [ngClass]="{'badge-success': isSumMatching, 'badge-danger': !isSumMatching}" style="font-size: 1.1rem; padding: 8px 12px;">
                    {{ currentWeightedSum }} / {{ question.customs?.weight_sum || 100 }}
                  </span>
                </div>
              } @else {
                <div class="mt-2 p-3 bg-light rounded d-flex align-items-center text-muted">
                  <mat-icon class="mr-2">info_outline</mat-icon>
                  <span>{{ "generic.abstained" | translate }}</span>
                </div>
              }
            </div>
          </div>
        }
        @if (isRankingQuestion) {
          <div class="mb-4">
            <h4 class="font-weight-bold col-12 w-100 pl-0 mt-4 mb-2 d-flex align-items-center section-title-purple">
              <mat-icon class="section-icon mr-2">format_list_numbered</mat-icon>
              {{ "generic.ranking" | translate }}
            </h4>
            <p class="mb-3 text-muted ml-2">
              {{ "pages.surveys.response.ranking.instruction" | translate }}
            </p>
            <div class="answer-card">
              @for (choice of question.choices; track choice; let optionIndex = $index) {
                <div class="row align-items-center mb-3 m-0">
                  <div class="col-8 pl-0">
                    <span class="option-title-text font-weight-bold">{{ choice.title }}</span>
                  </div>
                  <div class="col-4 pr-0">
                    <mat-form-field appearance="outline" class="w-100 mb-0">
                      <mat-label>{{ "generic.position" | translate }}</mat-label>
                      <mat-select [disabled]="survey.answered"
                                  [value]="question.response.answer[choice.id]"
                                  (selectionChange)="onRankChange(choice.id, $event.value)">
                        <mat-option [value]="null">--</mat-option>
                        @for (rank of rankingOptions; track rank) {
                          <mat-option [value]="rank">{{ rank }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @if (!isConsensusQuestion && !isOpenedQuestion) {
          <h4 class="font-weight-bold col-12 w-100 pl-0 mt-4 mb-2 d-flex align-items-center section-title-purple">
            <mat-icon class="section-icon mr-2">rate_review</mat-icon>
            {{ "pages.surveys.responses.comment-your-answer" | translate }}
            (@if (getCustoms.feedback_is_mandatory) {
              <span class="ml-1">{{ 'generic.required' | translate }}</span>
            } @if (!getCustoms.feedback_is_mandatory) {
              <span class="ml-1">{{ "generic.optional" | translate }}</span>
            })
          </h4>
          <div class="answer-card answer-card-soft">
            <mat-form-field class="w-100 answer-field" appearance="outline">
              <mat-label>{{ "generic.your-answer" | translate }}</mat-label>
              <ng-container>
                <textarea class="description" matInput name="criterio_description{{question.id}}_response" rows="3"
                  [(ngModel)]="question.response.feedback" [ngModelOptions]="{standalone: true}" [required]="getCustoms?.feedback_is_mandatory"
                  [disabled]="survey.answered">
                </textarea>
              </ng-container>
            </mat-form-field>
          </div>
        }
        <div class="mt-4 row">
          @if (isResponse) {
            <div class="col-12">
              <app-attachments-list [attachments]="question.response.attachments" [editable]="!survey.answered" [buttonToAdd]="survey?.attachments_enabled"></app-attachments-list>
            </div>
          }
        </div>
        <div class="question-actions-buttons">
          <div class="question-actions-row">
            <div class="question-actions-left">
              @if (question?.attachments?.length > 0) {
                <button mat-stroked-button class="documentation-attached-btn" (click)="showAttachments()">
                  <fa-icon [icon]="faFolderOpen" class="documentation-icon"></fa-icon>
                  {{ "generic.documentation-attached" | translate }}
                </button>
              }
            </div>
            <div class="question-actions-right">
              <!-- No more 'Add' button here as it's now inside app-attachments-list -->
            </div>
          </div>
        </div>
      }
      @if (!isResponse) {
        <!-- Top Row: Name, Section, Type -->
        <div class="row justify-content-between">
          <div class="col-6">
            <mat-form-field appearance="fill" class="w-100 pb-0">
              <mat-label>{{ "generic.title" | translate }} </mat-label>
              <input required [disabled]="!editable" [(ngModel)]="question.question" [ngModelOptions]="{standalone: true}" matInput
                name="criterio_title_{{question.id}}">
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field appearance="fill" class="w-100 pb-0">
              <mat-label>{{ "generic.section" | translate }}</mat-label>
              <input [disabled]="!editable" [(ngModel)]="getCustoms.section" [ngModelOptions]="{standalone: true}" matInput
                name="criterio_section_{{question.id}}">
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="w-100 pb-0" appearance="fill">
              <mat-label>{{ "generic.type" | translate }} </mat-label>
              <mat-select name="question_typology_{{question.id}}" [disabled]="!editable" required
                [(ngModel)]="question.typology" [ngModelOptions]="{standalone: true}" (selectionChange)="onTypologyChange()"
                name="criterio_typology_{{question.id}}">
                @for (typology of surveyService.questionTypologies; track typology) {
                  <mat-option [disabled]="!editable"
                    [value]="typology.id">{{ typology.title | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        @if (getCustoms?.use_description) {
          <div class="w-100 mb-4">
            <div class="box py-0 px-2 bg-transparent border-0 mb-0">
              <mat-label class="box-title p-0 mb-0">{{ "generic.description" | translate }}</mat-label>
            </div>
            <app-rich-text-editor [(ngModel)]="question.description" name="criterio_description{{question.id}}" [ngModelOptions]="{standalone: true}"
              placeholder="{{ 'components.proposals.new-proposal.placeholders.insert-description' | translate }}" id="criterio_description{{question.id}}"
              [disabled]="!editable"></app-rich-text-editor>
          </div>
        }
        <!-- Quantitative Settings -->
        @if (isQuantitativeQuestion) {
          <div class="w-100">
            <app-question-quantitative [question]="question" [editable]="editable"
            [isResponse]="isResponse"></app-question-quantitative>
          </div>
        }
        <!-- Consensus Question -->
        @if (isConsensusQuestion) {
          <div class="w-100">
            <app-question-consensus [question]="question" [editable]="editable"
            [isResponse]="isResponse"></app-question-consensus>
          </div>
        }
        @if (isMultipleChoiceQuestion || isCheckboxQuestion || isWeightedQuestion || isRankingQuestion) {
          <div class="mt-0 mb-3 w-100">
            <app-question-options [question]="question" [editable]="editable"></app-question-options>
          </div>
        }
        @if (isWeightedQuestion || isClassificationQuestion) {
          <div class="row mt-2 mb-3 align-items-center">
            <div class="col-md-4 col-sm-6">
              <mat-form-field appearance="fill" class="w-100 pb-0">
                <mat-label>{{ "components.surveys.target-sum" | translate }}</mat-label>
                <input type="number" matInput required [disabled]="!editable" min="1"
                  [(ngModel)]="getCustoms.weight_sum" [ngModelOptions]="{standalone: true}"
                  name="criterio_weight_sum_{{question.id}}" placeholder="100">
              </mat-form-field>
            </div>
            @if (isWeightedQuestion && getCustoms?.use_exclusivity) {
              <div class="col-md-8 col-sm-6">
                <mat-form-field appearance="fill" class="w-100 pb-0">
                  <mat-label>{{ "components.surveys.exclusivity-text" | translate }}</mat-label>
                  <input type="text" matInput [disabled]="!editable"
                    [(ngModel)]="getCustoms.exclusivity_text" [ngModelOptions]="{standalone: true}"
                    name="criterio_exclusivity_text_{{question.id}}" placeholder="{{ 'components.surveys.exclusivity-text-placeholder' | translate }}">
                </mat-form-field>
              </div>
            }
          </div>
        }
        @if (isGridQuestion || isClassificationQuestion) {
          <div class="w-100">
            <app-grid-question-table class="w-100" [editable]="editable" [(rows)]="question.grid_rows"
            [(columns)]="question.grid_columns" [isResponse]="isResponse"></app-grid-question-table>
          </div>
        }
        @if (!(canManageAttachments === false && question?.attachments?.length === 0)) {
          <div class="question-actions-buttons">
            <div class="question-actions-row">
              <div class="question-actions-left">
                @if (question?.attachments.length > 0) {
                  <button mat-stroked-button class="documentation-attached-btn" (click)="showAttachments()">
                    <fa-icon [icon]="faFolderOpen" class="documentation-icon"></fa-icon>
                    {{ "generic.documentation-attached" | translate }}
                  </button>
                }
              </div>
              <div class="question-actions-right">
                @if (canManageAttachments) {
                  <button mat-icon-button class="allega-evidenze-btn" aria-label="add attachment"
                    [matMenuTriggerFor]="menuAttachment">
                    <mat-icon>attach_file</mat-icon>
                  </button>
                  <mat-menu #menuAttachment="matMenu">
                    <button mat-menu-item (click)="onClickAddNewEvidence('PUBMED')">
                      <mat-icon aria-hidden="false" class="attachment-evidence-icon">science</mat-icon>
                      Pubmed
                    </button>
                    <button mat-menu-item (click)="onClickAddNewEvidence('FILE')">
                      <mat-icon aria-hidden="false" class="attachment-evidence-icon">insert_drive_file</mat-icon>
                      File
                    </button>
                    <button mat-menu-item (click)="onClickAddNewEvidence('LINK')">
                      <mat-icon aria-hidden="false" class="attachment-evidence-icon">link</mat-icon>
                      Link
                    </button>
                  </mat-menu>
                  @if (clonable) {
                    <button mat-icon-button class="allega-evidenze-btn" aria-label="duplicate"
                      (click)="duplicateQuestion()">
                      <mat-icon>file_copy</mat-icon>
                    </button>
                  }
                  @if (isDeletable) {
                    <button (click)="removeQuestion()" mat-icon-button class="allega-evidenze-btn" aria-label="delete">
                      <mat-icon>delete</mat-icon>
                    </button>
                  }
                  <button mat-icon-button class="allega-evidenze-btn" aria-label="settings"
                    [matMenuTriggerFor]="menuSettings">
                    <mat-icon>settings</mat-icon>
                  </button>
                  <mat-menu #menuSettings="matMenu">
                    @for (option of surveyService.selectOptions; track option) {
                      @if (option.enabledTypologies.includes(question.typology)) {
                        <div mat-menu-item (click)="settingsItemSelected($event)">
                          <mat-checkbox name="custom_option_{{question.id}}_{{option.key}}"
                            [(ngModel)]="getCustoms[option.key]" [ngModelOptions]="{standalone: true}">{{ option.label | translate }}</mat-checkbox>
                        </div>
                      }
                    }
                  </mat-menu>
                  <div class="question-actions-toggle">
                    <mat-button-toggle-group [(ngModel)]="question.required" [ngModelOptions]="{standalone: true}" name="question_{{question.id}}_required"
                      [hideMultipleSelectionIndicator]="true" [hideSingleSelectionIndicator]="true">
                      <mat-button-toggle [value]="true">{{ "generic.required" | translate }}</mat-button-toggle>
                      <mat-button-toggle [value]="false">{{ "generic.optional" | translate }}</mat-button-toggle>
                    </mat-button-toggle-group>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      }
    </mat-expansion-panel>
  </mat-accordion>
</div>
